import styled from '@emotion/styled'

export const MBUnorderedList = styled.ul`
  list-style: none;
`
export const MBListItem = styled.li`
  position: relative;
  padding-left: 1.6rem;
  
  &:not(:last-child) { 
   margin-bottom: 8px;  
  }
  
  &:before{
    position: absolute;
    content: "";
    display: inline-block;
    text-align : center;
    vertical-align: middle;
    top: 7px;
    left: 5px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #000;
  }
`
